import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { v4 as uuidv4 } from 'uuid';

import { API_BASE } from '@/config/config';
// import { ENVIRONMENT, TOKEN } from '@/config/config';
import { setErrorData } from '@/features/error/errorSlice';
import { hideLoader, showLoader } from '@/features/loader/loaderSlice';
import { sendAxiosDefaultErrorAnalytics, sendErrorAnalytics } from '@/helpers/analytics';
import { compareTwoStr } from '@/helpers/utils';
import { store } from '@/redux/store';


const axiosInstance = axios.create({
  baseURL:
    (API_BASE && `${API_BASE}`) ||
    'http://localhost:3001'
});

axiosInstance.interceptors.request.use((config) => {
  if (isEmpty(config.headers) || isEmpty(config.headers.Authorization)) {
    let { token: tokenObject } = store.getState();
    let { token } = tokenObject;

    // if (ENVIRONMENT === "dev" && !token) {
    //   token = TOKEN;
    // }
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.headers["X-Trace-Id"] = uuidv4();

  if (!config.hideLoader) {
    store.dispatch(showLoader());
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (!response.config.hideLoader) {
      store.dispatch(hideLoader());
    }

    return response.data;
  },
  (error) => {
    const defaultErrorCode = "FE_DEF_ERR";
    const timeoutErrorCode = "FE_TIMEOUT_ERR";
    const timeoutCodeByAxios = "ECONNABORTED";
    const defaultMsg =
      "Oops! This shouldn't have happened. We are working to get this fixed as soon as we can. Request you to try again in some time.";
    if (!error.config?.hideLoader) {
      store.dispatch(hideLoader());
    }
    if (!error.config?.hideErrorModal) {
      let msg = error?.response?.data?.message
        ? error?.response?.data?.message
        : defaultErrorCode.concat(`: ${defaultMsg}`);

      if (compareTwoStr(error?.code, timeoutCodeByAxios)) {
        msg = timeoutErrorCode.concat(`: ${defaultMsg}`);
      }
      store.dispatch(
        setErrorData({
          errorData: {
            show: true,
            showCommonModal: true,
            status: error?.response?.status,
            msg,
          },
        })
      );
    }

    let msg = error?.response?.data?.message
      ? error?.response?.data?.message
      : defaultErrorCode.concat(`: ${defaultMsg}`);

    if (compareTwoStr(error?.code, timeoutCodeByAxios)) {
      msg = timeoutErrorCode.concat(`: ${defaultMsg}`);
      sendAxiosDefaultErrorAnalytics(timeoutErrorCode, error?.config, msg);
    } else if (msg === defaultErrorCode.concat(`: ${defaultMsg}`)) {
      msg = error?.response?.status?.toString().concat(`:- ${msg}`);
      sendAxiosDefaultErrorAnalytics(
        defaultErrorCode,
        error?.response?.config,
        msg
      );
    } else {
      msg = error?.response?.status?.toString().concat(`:- ${msg}`);
      sendErrorAnalytics(error?.response?.config, msg);
    }

    return Promise.reject(error?.response);
  }
);

export default axiosInstance;
